export const languageSettingsData = [
    {
        id: '1',
        language: 'English',
        code: 'en',
    },
    {
        id: '3',
        language: 'French',
        code: 'fr',
    },
    {
        id: '2',
        language: 'Spanish',
        code: 'es',
    },
  ].sort((a, b) => a.language.localeCompare(b.language))
